import React from 'react';

const Cgv = () => {
    return (
        <div id='cgv-container'>
            <div className="brand-logo">
                <h1>
                    <span>B</span>k-
                    <span>E</span>lite.
                </h1>
            </div>
            <div className="cgv-title">
                <h2>Conditions générales de vente</h2>
                <h3>Bk-Elite-E-Transport</h3>
            </div>
            <div className="cgv-txt">
                <div className="cgv-part">
                    <h3>PRÉAMBULE</h3>
                    <p>
                        Toute réservation effectuée auprès de Bk-Elite-E-Transport entraîne une acceptation sans réserve des présentes conditions générales de vente.
                        <br />
                        Le terme « client » désigne toute personne physique ou morale faisant appel aux services de la société Bk-Elite-E-Transport .
                        <br />
                        Le chauffeur effectuant la prestation s'engage à respecter les présentes conditions générales de vente et pourra décider d'une exclusion temporaire des termes des présentes CGV à l'encontre de tout client les ayant enfreints, selon la gravité des faits. Dans ce cas, aucun remboursement ou indemnité ne seront dus.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 1 - RESERVATIONS</h3>
                    <p>
                        Toute prestation de la société Bk-Elite-E-Transport  doit faire l'objet d'une réservation préalable, confirmée par écrit (par e-mail, SMS ou validation du bon de réservation sur place). Elle peut être effectuée par le client ou un mandataire dûment autorisé.
                        <br />
                        Les réservations peuvent être effectuées sur le site internet www.bk-elite.fr, par téléphone ou par e-mail.
                        <br />
                        Toute réservation doit mentionner les informations suivantes :
                        <br />
                        - Le nom et les coordonnées de la personne physique ou morale pour le compte duquel le transport est effectué,
                        <br />
                        - Le nombre de passagers,
                        <br />
                        - La date et l'heure de prise en charge,
                        <br />
                        - Le lieu de prise en charge,
                        <br />
                        - Le lieu de dépose,
                        <br />
                        - La date et l'heure de réservation,
                        <br />
                        - Le prix de la prestation et le montant de l'acompte versé,
                        <br />
                        - Le nombre de bagages et leur taille,    
                        <br />
                        - Durée de la prestation pour les mises à disposition.
                        <br />
                        Toute spécificité (animaux, bagages spéciaux, transport d'enfants en siège auto…) doit être précisée au moment de la réservation, sans quoi la société Bk-Elite-E-Transport ne pourrait honorer la prestation.
                        <br />
                        Ces informations seront apposées sur le Bon de Réservation faisant office de contrat de transport entre le client et la société Bk-Elite-E-Transport 
                        <br />
                        Les animaux de compagnie devront obligatoirement être tenus en laisse ou en cage et leur présence devra être précisée au moment de la réservation.
                        <br />
                        La quantité et la taille des bagages doivent être précisées au moment de la réservation. Dans le cas contraire, la société Bk-Elite-E-Transport se réserve le droit de refuser tout ou partie des bagages, voire d'effectuer la prestation (volume des bagages transportés proportionnel à la capacité du véhicule).
                        <br />
                        Chaque bagage ne pourra excéder 35 kg par passager et ces derniers ne devront pas présenter de risque de détérioration pour le véhicule.
                        <br />
                        La réservation ne sera validée que par le versement d'un acompte de 50% minimum du montant total de la prestation. Dans un souci de disponibilité des chauffeurs de la société Bk-Elite-E-Transport , la réservation devra être effectuée, dans la mesure du possible, au minimum 24h à l'avance. Dans le cas d'une prestation de mise à disposition, trajet longue distance ou autre service spécifique, un délai de réservation de 48h à l'avance est demandé.
                        <br />
                        La société Bk-Elite-E-Transport  se réserve le droit de refuser la réservation en cas d'indisponibilité des véhicules.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 2 - PRESTATION</h3>
                    <p>
                        La prestation n'est valable qu'une fois.
                        <br />
                        La prestation débute au jour et à l'heure fixés préalablement entre le client et la société Bk-Elite-E-Transport , et au départ du lieu donné par le client. Elle se termine au jour et à l'heure de retour du véhicule à son lieu de départ.
                        <br />
                        En cas de retard ou d'absence du client sur le lieu de prise en charge préalablement fixé, le chauffeur patientera 15 minutes. Passé ce délai, la société Bk-Elite-E-Transport considérera la prestation annulée. Celle-ci sera facturée au client et ne donnera lieu à aucun remboursement.
                        <br />
                        Sont inclus dans la prestation :
                        <br />
                        - Le véhicule mis à disposition du client,
                        <br />
                        - La mise à disposition d'un chauffeur s'exprimant au minimum en français,
                        <br />
                        - L'assurance professionnelle pour les passagers transportés à titre onéreux, les kilomètres parcourus, l'entretien du véhicule, le carburant et la durée déterminée lors de la réservation de la prestation,
                        <br />
                        - Le transport des bagages du client dans la limite des possibilités du véhicule,
                        <br />
                        - Le coût des péages,
                        <br />
                        Ne sont pas inclus dans la prestation :
                        <br />
                        - Le coût des parkings et lieux de stationnement,   
                        <br />
                        - Les frais d'entrée sur les sites (musées, théâtres, stades…),
                        <br />
                        - Les droits d'entrée dans les lieux publics.
                        <br />
                        - La société Bk-Elite-E-Transport se réserve le droit de refuser, pour quelque raison que ce soit, tout service qu'elle juge infaisable.
                        <br />
                        Pour les déplacements prévus sur plusieurs jours, les tarifs forfaitaires suivants seront facturés au client :
                        <br />
                        - Forfait repas de 25,00€ TTC par jour,
                        <br />
                        - Forfait nuit d'hôtel + petit déjeuner de 120,00€ TTC par jour.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 3 - MODIFICATION EN COURS DE SERVICE</h3>
                    <p>
                        Toute modification du trajet en cours de prestation par le client pourra engendrer des frais supplémentaires qui lui seront facturés.
                        <br />
                        Ces demandes engendrant une modification du Bon de Réservation, le chauffeur est en droit d'accéder ou non à la requête du client.
                        <br />
                        Pour les mises à disposition, toute heure commencée est due et toute heure supplémentaire au forfait établi par le contrat sera facturé au tarif en vigueur.
                        <br />
                        Pour les transferts tout kilomètre supplémentaire au forfait établi par le contrat sera facturé au tarif en vigueur.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 4 - ANNULATION</h3>
                    <p>
                        Toute annulation de la prestation, intervenant entre la réservation et les 48h précédant le service, entraînera une facturation de 50% du montant de la prestation totale.
                        <br />
                        Toute annulation de la prestation, intervenant entre les 48h et l'heure ou au-delà de l'heure de prise en charge, entraînera une facturation de 100% du montant de la prestation totale.
                        <br />
                        Au-delà du délai de 15 minutes d'attente sur le lieu de prise en charge, la prestation est considérée comme due et facturée au client.
                        <br />
                        En cas d'absence du client sur le lieu de prise en charge, la prestation est considérée comme due et facturée au client.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLES 5 - CONDITIONS DE SERVICE</h3>
                    <p>
                        Le conducteur est autorisé à refuser objectivement l'accès au véhicule à un client au comportement induisant un risque manifeste de trouble à l'ordre public (ivresse, agressivité, violences diverses…) ou risquant d'importuner les autres usagers (manque d'hygiène…).
                        <br />
                        Lorsque le client manifeste l'un de ces comportements au cours du trajet, le conducteur peut l'obliger à quitter le véhicule (les passagers mineurs ayant ce type de comportement seront déposés à la gendarmerie ou au poste de police le plus proche).
                        <br />
                        Le chauffeur se réserve le droit de refuser toutes instructions ou demandes du client qu'il considérait comme étant de nature à compromettre la sécurité des occupants du véhicule et des autres usagers de la route.
                        <br />
                        Le client doit :
                        <br />
                        - voyager assis,
                        <br />
                        - attacher obligatoirement sa ceinture de sécurité (article R 412-1 du Code de la route) à l'avant et à l'arrière du véhicule,
                        <br />
                        - respecter les conditions de service mises en place par la société Bk-Elite-E-Transport.
                        <br />
                        A bord de nos véhicules, il est interdit de :
                        <br />
                        - fumer (décret n 92-478 du 29 mai 1992),
                        <br />
                        - mettre ses pieds sur les sièges,
                        <br />
                        - souiller ou dégrader le matériel, jeter des détritus par les fenêtres,
                        <br />
                        - voyager avec des objets inflammables, toxiques, dangereux ou nauséabonds,
                        <br />
                        - gêner le conducteur et/ou sa conduite sans raison impérieuse,
                        <br />
                        - troubler par quelque attitude que ce soit la circulation et les autres usagers de la route,
                        <br />
                        - manœuvrer les issues de secours ou tout organe d'ouverture / fermeture des portes, sauf en cas d'accident,
                        <br />
                        - se déplacer dans le véhicule durant le trajet (article 223-1 du Code Pénal),
                        <br />
                        - manipuler briquets, allumettes, cutters, canifs, ciseaux ou tout objet susceptible de mettre en danger la santé et la sécurité d'autrui (article 223-1 du Code Pénal),
                        <br />
                        troubler la tranquillité des voyageurs,
                        <br />
                        exiger que le chauffeur dépasse les limitations de vitesse ou de commettre des infractions de la route.
                        <br />
                        Bk-Elite-E-Transport  se réserve le droit d'interrompre la prestation en cours si le client commet une infraction ou si le comportement du client met en danger la sécurité du chauffeur ou d'autrui.
                        <br />
                        Le respect et le bon usage du matériel sont de rigueur. Toute détérioration du matériel et tout dommage causé à l'intérieur du véhicule sera à la charge du client et lui sera facturé.
                        <br />
                        La dégradation et autres actes de vandalisme et d'incivilités feront l'objet de poursuites avec demande de réparations ou dédommagements.
                        <br />
                        Le conducteur est le seul à ouvrir et fermer le coffre afin de charger et décharger son contenu. Il veille à la sécurité des voyageurs de leur prise en charge à leur descente du véhicule.
                        <br />
                        Bk-Elite-E-Transport  reconnaît l'obligation de prendre les mesures nécessaires à la préservation de la sécurité des occupants du véhicule.
                        <br />
                        La société Bk-Élite-E-Transport  interdit toute matières dangereuses, toxiques, incommodantes ou illégales à bord des véhicules, même dans les bagages.
                        <br />
                        Les bagages ou tout autre objet appartenant au client sont sous sa responsabilité.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 6 - LIMITES DE RESPONSABILITÉS</h3>
                    <p>
                        La responsabilité de la société Bk-Elite-E-Transport ne peut être engagée en cas de dégradations, pertes ou vols du contenu des bagages ou des bagages transportés.
                        <br />
                        La société Bk-Elite-E-Transport ne peut en aucun cas être tenue responsable des retards dus au trafic routier indépendants de sa volonté (route barrée, pont interdit à la circulation, embouteillages, route inondée, manifestations, conditions météorologiques, intervention des forces de police, pompiers ou douanes, …) liste non exhaustive.
                        <br />
                        Bk-Elite-E-Transport ne peut en aucun cas être tenu responsable de retards directement issus d'un retard initial du client ou de la nécessité d'effectuer un trajet à la demande du client dans un délai manifestement trop court.
                        <br />
                        En cas d'immobilisation du véhicule due à une défaillance mécanique, accident, ou dommage, Bk-Elite-E-Transport s'efforcera d'assurer la continuité du parcours avec un autre véhicule ou un véhicule affrété à une autre entreprise.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 7 - ASSURANCES</h3>
                    <p>
                        La responsabilité de la société Bk-Elite-E-Transport  est limitée aux clauses de son contrat d'assurance et son assurance professionnelle « souscrite pour le transport de passagers à titre onéreux ».
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 8 - DONNEES PERSONNELLES</h3>
                    <p>
                        Bk-Elite-E-Transport s'engage à respecter la vie privée de ses clients et les informations collectées auprès de ceux-ci ne seront en aucun cas transmises à des tierces personnes, conformément à la loi française Informatique et Libertés n°78-17 du 6 janvier 1978.
                        <br />
                        Les droits d'accès et de rectification s'exercent auprès du siège social de la société Bk-Elite-E-Transport.
                    </p>
                </div>
                <div className="cgv-part">
                    <h3>ARTICLE 9 - RÉCLAMATIONS ET LITIGES</h3>
                    <p>
                        Toute réclamation doit être adressée à M. Benabdenbi Kamal président de la société Bk-Elite-E-Transport , par lettre recommandée avec accusé de réception à l'adresse du siège social : 8 Albert camus 30150 Roquemaure, sous un délai maximum de 5 jours / 120 heures après l'exécution de la prestation.
                        <br />
                        Passé ce délai, seul sera compétent le Tribunal de Commerce du gard ou du vaucluse.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Cgv;